module.exports = __webpack_public_path__ + "img/MDI-family-tree.29df4541.svg";